"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAutosellingProfileContext } from "@/app/my-cars/contexts/autoselling-profile-context";

export default function HomePage() {
	const router = useRouter();
	const { profile, isLoading } = useAutosellingProfileContext();

	useEffect(() => {
		if (isLoading) return;

		// New users: go to capability discovery onboarding
		if (profile && !profile.infinit_ai_onboarding_completed) {
			router.replace("/onboarding/capability-discovery");
			return;
		}

		router.replace("/dashboard");
	}, [profile, isLoading, router]);

	return null;
}
